import i18n from '../../language/index'
import {create_title} from '@/base/titleData';
import {getMbInforFromPCInfor} from '@/utils/utils'

let pc_widgets_infor = {
  title: create_title('Horizontal layout'),
  moduleStyle: 1,
  tagLayout: 'left',
  tagPosition: 'top',
  tagFont: {
    radio_val: 'default',
    default: {
      fontSize: 14,
      fontWidth: 'normal',
      fontColor: 'rgba(33,33,33,1)',
      fontSeColor: 'rgba(33,33,33,1)',
      fontFamily: 'Arial',
      pattern: 'pure_color',
      fontStyle: '',
      fontWeight: 'normal',
      fontItalics: 'normal',
      fontUnderline: 'none',
      linear_gradient: {
        start_color: "rgba(0,120,215,1)",
        end_color: "rgba(0, 0, 0,1)",
        start_pointer: 12,
        end_pointer: 100,
        deg: 90
      },
    },
    custom: {
      fontSize: 12,
      fontWidth: 'normal',
      fontColor: 'rgba(33,33,33,1)',
      fontSeColor: 'rgba(33,33,33,1)',
      fontFamily: 'Arial',
      pattern: 'pure_color',
      fontStyle: '',
      fontWeight: 'normal',
      fontItalics: 'normal',
      fontUnderline: 'none',
      linear_gradient: {
        start_color: "rgba(0,120,215,1)",
        end_color: "rgba(0, 0, 0,1)",
        start_pointer: 12,
        end_pointer: 100,
        deg: 90
      },
    },
  },
  tagBackground: {
    radio_val: 'default',
    default: {
      type: 'color', // 背景设置-类型
      img: '', // 背景设置-图片的URL
      color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
      img_scale: 'scale_cover', //图片缩放 填充、等比例、平铺、拉伸、原图
      tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
      background_size: 'cover',
      background_repeat: 'no-repeat',
      background_position: 'center center' //图片位置
    },
    custom: {
      type: 'color', // 背景设置-类型
      img: '', // 背景设置-图片的URL
      color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
      img_scale: 'scale_cover', //图片缩放 填充、等比例、平铺、拉伸、原图
      tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
      background_size: 'cover',
      background_repeat: 'no-repeat',
      background_position: 'center center' //图片位置
    }
  },
  tagBorder: {
    radio_val: 'default',
    default: {
      border_width: 1,
      border_left_width: 1,
      border_right_width: 1,
      border_top_width: 1,
      border_bottom_width: 1,
      border_color: 'rgba(240,240,240,1)',
      border_style: 'solid',
      border_check_list: ['borderTopWidth', 'borderBottomWidth', 'borderLeftWidth', 'borderRightWidth']
    },
    custom: {
      border_width: 0,
      border_left_width: 0,
      border_right_width: 0,
      border_top_width: 0,
      border_bottom_width: 0,
      border_color: 'rgba(0,0,0,1)',
      border_style: 'solid',
      border_check_list: ['borderTopWidth', 'borderBottomWidth', 'borderLeftWidth', 'borderRightWidth']
    }
  },
  tagSplitLine: {
    radio_val: 'default',
    default: {
      type: 'vertical',
      color: 'rgba(0,0,0,1)'
    },
    custom: {
      type: 'vertical',
      color: 'rgba(0,0,0,1)'
    }
  },
  tagFontSelect: {
    radio_val: 'default',
    default: {
      fontSize: 14,
      fontWidth: 'normal',
      fontColor: 'rgba(255,255,255,1)',
      fontSeColor: 'rgba(255,255,255,1)',
      fontFamily: 'Arial',
      pattern: 'pure_color',
      fontStyle: '',
      fontWeight: 'normal',
      fontItalics: 'normal',
      fontUnderline: 'none',
      linear_gradient: {
        start_color: "rgba(0,120,215,1)",
        end_color: "rgba(0, 0, 0,1)",
        start_pointer: 12,
        end_pointer: 100,
        deg: 90
      },
    },
    custom: {
      fontSize: 12,
      fontWidth: 'normal',
      fontColor: 'rgba(50,50,50,1)',
      fontSeColor: 'rgba(50,50,50,1)',
      fontFamily: 'Arial',
      pattern: 'pure_color',
      fontStyle: '',
      fontWeight: 'normal',
      fontItalics: 'normal',
      fontUnderline: 'none',
      linear_gradient: {
        start_color: "rgba(0,120,215,1)",
        end_color: "rgba(0, 0, 0,1)",
        start_pointer: 12,
        end_pointer: 100,
        deg: 90
      },
    },
  },
  tagBackgroundSelect: {
    radio_val: 'default',
    default: {
      type: 'color', // 背景设置-类型
      img: '', // 背景设置-图片的URL
      color: 'var(--theme_color)',
      img_scale: 'scale_cover', //图片缩放 填充、等比例、平铺、拉伸、原图
      tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
      background_size: 'cover',
      background_repeat: 'no-repeat',
      background_position: 'center center' //图片位置
    },
    custom: {
      type: 'color', // 背景设置-类型
      img: '', // 背景设置-图片的URL
      color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
      img_scale: 'scale_cover', //图片缩放 填充、等比例、平铺、拉伸、原图
      tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
      background_size: 'cover',
      background_repeat: 'no-repeat',
      background_position: 'center center' //图片位置
    }
  },
  tagBorderSelect: {
    radio_val: 'default',
    default: {
      border_width: 0,
      border_left_width: 0,
      border_right_width: 0,
      border_top_width: 0,
      border_bottom_width: 0,
      border_color: 'rgba(0,0,0,1)',
      border_style: 'solid',
      border_check_list: ['borderTopWidth', 'borderBottomWidth', 'borderLeftWidth', 'borderRightWidth']
    },
    custom: {
      border_width: 0,
      border_left_width: 0,
      border_right_width: 0,
      border_top_width: 0,
      border_bottom_width: 0,
      border_color: 'rgba(0,0,0,1)',
      border_style: 'solid',
      border_check_list: ['borderTopWidth', 'borderBottomWidth', 'borderLeftWidth', 'borderRightWidth']
    }
  },
  tagHasShadowSelect: 'true',
  tagUnderlineSelect: 'long',
  tagArrowSelect: 'show',
  barBorder: {
    radio_val: 'default',
    default: {
      border_width: 0,
      border_left_width: 0,
      border_right_width: 0,
      border_top_width: 0,
      border_bottom_width: 0,
      border_color: 'rgba(0,0,0,1)',
      border_style: 'solid',
      border_check_list: ['borderTopWidth', 'borderBottomWidth', 'borderLeftWidth', 'borderRightWidth']
    },
    custom: {
      border_width: 0,
      border_left_width: 0,
      border_right_width: 0,
      border_top_width: 0,
      border_bottom_width: 0,
      border_color: 'rgba(0,0,0,1)',
      border_style: 'solid',
      border_check_list: ['borderTopWidth', 'borderBottomWidth', 'borderLeftWidth', 'borderRightWidth']
    }
  },
  tagMargin: {
    radio_val: 'default',
    default: {
      marginTop: 20,
      marginLeft: 10,
    },
    custom: {
      marginTop: 0,
      marginLeft: 0,
    }
  },
  tagBorderRadius: {
    radio_val: 'default',
    default: {
      value: 0,
    },
    custom: {
      value: 0
    }
  },
  triggerType: 'hover',
  tabPanelHeight: 'group',
  background: {
    radio_val: 'default',
    default: {
      type: 'color', // 背景设置-类型
      img: '', // 背景设置-图片的URL
      color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
      img_scale: 'scale_cover', //图片缩放 填充、等比例、平铺、拉伸、原图
      tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
      background_size: 'cover',
      background_repeat: 'no-repeat',
      background_position: 'center center' //图片位置
    },
    custom: {
      type: 'color', // 背景设置-类型
      img: '', // 背景设置-图片的URL
      color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
      img_scale: 'scale_cover', //图片缩放 填充、等比例、平铺、拉伸、原图
      tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
      background_size: 'cover',
      background_repeat: 'no-repeat',
      background_position: 'center center' //图片位置
    }
  },
  border: {
    radio_val: 'default',
    default: {
      border_width: 0,
      border_left_width: 0,
      border_right_width: 0,
      border_top_width: 0,
      border_bottom_width: 0,
      border_color: 'rgba(0,0,0,1)',
      border_style: 'solid',
      border_check_list: ['borderTopWidth', 'borderBottomWidth', 'borderLeftWidth', 'borderRightWidth']
    },
    custom: {
      border_width: 0,
      border_left_width: 0,
      border_right_width: 0,
      border_top_width: 0,
      border_bottom_width: 0,
      border_color: 'rgba(0,0,0,1)',
      border_style: 'solid',
      border_check_list: ['borderTopWidth', 'borderBottomWidth', 'borderLeftWidth', 'borderRightWidth']
    }
  },
  boxShadow: {
    radio_val: 'default',
    default: {
      direction: 'outset',
      x: 0,
      y: 0,
      spread: 0,
      blur: 0,
      color: 'rgba(0,0,0,0.3)',
    },
    custom: {
      direction: 'outset',
      x: 0,
      y: 0,
      spread: 0,
      blur: 4,
      color: 'rgba(0,0,0,0.3)',
    }
  },
}

let mb_widgets_infor = getMbInforFromPCInfor(pc_widgets_infor)

export default {
  pc_infor: {
    marginTop: '0%',
    marginLeft: '0%',
    marginRight: '0%',
    marginBottom: '0%',
    textAlign: 'left'
  },
  mb_infor: {
    marginTop: '0%',
    marginLeft: '1.733%',
    marginRight: '1.733%',
    marginBottom: '0%',
    textAlign: 'center'
  },
  pc_widgets_infor,
  mb_widgets_infor,
  animateCombObj: {
    value: 0,
    animate: {
      _key: 'none'
    }
  },
  animateType: 'module_animation',
  listArr: {
    tabs: [{
      name: i18n.t('widgets_basic_row_tab_style_2831'),
      id: '1'
    }, {
      name: i18n.t('widgets_basic_row_tab_style_2832'),
      id: '2'
    }]
  },
}



// WEBPACK FOOTER //
// ./src/widgets/basic_row_tab/style.js